export function createLeftButton(leftIconId: string) {
  const picker = document.getElementById(leftIconId) as HTMLElement;

  const buttonLeft = picker.getElementsByClassName('calendar-navigation button-left');

  if (buttonLeft[0]) {
    buttonLeft[0].setAttribute('hidden', 'true');
  }
}

export function createRightButton(rightIconId: string) {
  const picker = document.getElementById(rightIconId) as HTMLElement;

  const buttonRight = picker.getElementsByClassName('calendar-navigation button-right');

  if (buttonRight[0]) {
    buttonRight[0].setAttribute('hidden', 'true');
  }
}
